import { Component } from '@angular/core';
import { DialogBaseComponent } from './dialog_base.component';
import { ENV } from '../../../environment';
import { RedirectService } from '../../../shared/services/redirect.service';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { ManualSetupState } from '../main/manual_setup/store/manual_setup_state';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yi-integrate-post-automatic-install-dialog',
  template: require('./post_automatic_install.component.html'),
  styles: [require('./install_automatically_approval.component.scss'), require('./post_automatic_install.component.scss')]
})
export class PostAutomaticInstallComponent extends DialogBaseComponent {

  private redirectService;
  private productLiquid = null;
  private website = null;
  private isWidgetV3: boolean;

  constructor(redCrossService: AnalyticsTrackingProvider,
              store: Store<IAppState>,
              redirectService: RedirectService) {
    super('', redCrossService, false);
    this.redirectService = redirectService;
    store.select(state => state.app.install.manualSetup).subscribe(
      (items: ManualSetupState) => {
        for (let item of items.accordionItems) {
          if (item.data.productLiquid) {
            this.productLiquid = item.data.productLiquid;
            this.setWebsite();
            break;
          }
        }
      }
    );
    store.select(state => state.app.install.integrate).pipe(take(1)).subscribe(
      items => {
        this.isWidgetV3 = items.hasWidgetV3;
      });
  }

  setWebsite() {
    let link = (document as any).createElement('a');
    link.setAttribute('href', this.productLiquid);
    this.website = link.origin;
  };

  continueToAdmin() {
    this.sendEvent('Continue to Admin');

    this.redCross.track(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step 3',
      phase: 3,
      status: 'completed',
      ctaText: 'automatic'
    });

    this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.COMPLETED,
      isSkipped: 0,
      isWidgetV3: this.isWidgetV3,
      endScenario: REDCRSS_EVENTS.AUTO_INSTALLATION
    });

    this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint);
  };

  close() {
    this.sendEvent('Close');
    this.closeDialog.emit();
  }

  openTemplate() {
    this.sendEvent('product.liquid template');
    this.openExternalLink(this.productLiquid);
  };

  openWebsite() {
    this.sendEvent('Website');
    this.openExternalLink(this.website);
  };

  sendEvent(text) {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: text
    });
  }

  openExternalLink(url) {
    this.redirectService.redirectTo(url, true);
  };
}




